import { API_AI_REROLL_TEXT } from "Constants";
import { api } from "./api";

export const getNewTextWithAI = async (text)  => {
  if (text) {
    const data = {
      generate: 'similar',
      text:text
    };
    const res = await api(API_AI_REROLL_TEXT, 'POST', data);
    return res.newText;
  }
}
